import React from 'react'
import { IPageRenderConfig } from '@fareye/types'
import { RenderControl } from '@fareye/ui'
import { IMapper, useMapper } from '@fareye/common'
import { TerminalView } from './TerminalView'
import version from './../config/npmVersions'

export const TerminalViewMapper = function(props: IMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  return (
    <RenderControl variant="m" state={apiData}>
      <TerminalView {...props} config={apiData.data as IPageRenderConfig} />
    </RenderControl>
  )
}
